import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Card, Form, Button } from "react-bootstrap";
import { ArrowLeftShort, ArrowRightShort, Check2Circle } from "react-bootstrap-icons";

function Test( {test, section, segments, onSegmentSelect, onTestSubmit} ) {
  const { submitTest } = useAuth();
  const [testResponses, setTestResponses] = useState({});
  const navigate = useNavigate();

  const pascalToSnake = (str) => {
    return str
      .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
      .toLowerCase();
  };

  const handleChange = (e) => {
    setTestResponses({ ...testResponses, [e.target.name]: e.target.value });
    console.log("Change handled")
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await submitTest(testResponses, section.slug, test.type, section.id);
    if (response.success) {
      console.log(response.test)
      onTestSubmit(pascalToSnake(response.test.type), response.test.section_id)
    } else {
      console.log(response.message);
    }
  }

  const percentageFormatter = new Intl.NumberFormat("default", {
    style: "percent",
  });

  const formattedTestScore = percentageFormatter.format(test?.existing_test?.score)

  function AnswerFormatting (option) {
    if (option.correct_answer === true) {
      return "text-success correct-mark fw-bold"
    } else if (test?.existing_test.responses.filter((response) => response.option_id === option.id).length > 0) {
      if (test?.existing_test.responses.filter((response) => response.option_id === option.id)[0].option.correct_answer === false) {
        return "text-danger wrong-mark fw-bold"
      }
    } else {
      return ""
    }
  }

  return (
    <Card className="segment-card">
      {test?.existing_test ? (
        test.existing_test.type === "PreTest" ? (
          <Card.Body className="text-center">
            <Check2Circle className="my-5 completed-pre-test-icon"/>
            <Card.Text className="mb-4 completed-pre-test-text">You have completed the Pre-Test for this course module.</Card.Text>
            {segments && segments[1] && (
              <div className="d-flex justify-content-end mt-5">
                <Button
                  className="purple-button"
                  onClick={() => {
                    onSegmentSelect(segments[1].slug);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                >
                  {segments[1].title} <ArrowRightShort fontSize="1.5rem" />
                </Button>
              </div>
            )}
          </Card.Body>
        ) : (
          <Card.Body>
            {test?.existing_test.section.questions?.map(question => (
              <div className="mb-5 test-form-text">
                {question.content}
                  <ul id='test-result-options'>
                    {question.options.map(option => (
                      <li className={AnswerFormatting(option)}>
                        {option.content}
                        {option.correct_answer === true ? <div className="alert alert-success fw-normal mb-0">{option.explanation}</div> : ""}
                      </li>
                    ))}
                  </ul>
              </div>
            ))}

            <div className="d-flex justify-content-start mt-4">
              <Button className="app-button" onClick={() => {
                navigate("/");
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}>
                <ArrowLeftShort fontSize="1.5rem" />Home
              </Button>
            </div>
          </Card.Body>
        )
      ) : (
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            {test?.questions?.map(question => (
              <Form.Group className="mb-5 test-form-text">
                <Form.Label key={question.id}>
                  {question.content}
                </Form.Label>
                {question.options.map(option => (
                  <Form.Check
                    key={option.id}
                    type="radio"
                    label={option.content}
                    name={`option-for-${question.id}`}
                    value={option.id}
                    onChange={handleChange}
                    required
                  />
                ))}
              </Form.Group>
            ))}
            <div className="d-flex justify-content-center test-form-text">
              <Button className="app-button" type="submit">Submit Test Answers</Button>
            </div>
          </Form>
        </Card.Body>
      )}
    </Card>
  );
}

export default Test;
